<h2 mat-dialog-title class="mat-title">
  <span >{{data.title}}</span>
  <span class="close-dialog" (click)="cancel()">&#10006;</span>
</h2>
<mat-dialog-content>
  <mat-stepper linear labelPosition="bottom" #stepper [@.disabled]="true">
    <mat-step [completed]="false" [editable]="false">
      <ng-template matStepLabel>Email</ng-template>
  @if (stepper.selectedIndex === 0) {
  <div>
    <div class="email-message">{{ data.message }}</div>
    <form (keydown.space)="$event.preventDefault()">
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label class="mat-label">{{ "COMPANY_ADD_USERS.email" | translate }}</mat-label>
        <input
          [formControl]="data.email"
          type="text"
          matInput
        />
        @if (
            data.email.errors &&
            !data.email.errors.emailExistsInUsers && !data.email.errors.emailExistsInInvitations &&
            (data.email.errors.required || data.email.errors.email)
          ) {
        <mat-error>
          {{ 'COMPANY_ADD_USERS.email_error' | translate }}
        </mat-error>
        }
        @if (data.email.errors && data.email.errors.emailExistsInUsers) {
        <mat-error>
          {{ 'COMPANY_ADD_USERS.user_exists_in_users_tab' | translate }}
        </mat-error>
        }
        @if (data.email.errors && data.email.errors.emailExistsInInvitations) {
        <mat-error>
          {{ 'COMPANY_ADD_USERS.user_exists_in_invites_tab' | translate }}
        </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  }
</mat-step>
<mat-step  [editable]="false"[completed]="false">
  <ng-template matStepLabel>{{ 'BRANCH_USERS_HEADER.branches' | translate }}</ng-template>
  @if (stepper.selectedIndex === 1) {
  <div>
    <form>
      <mat-form-field class="example-chip-list" appearance="outline"  floatLabel="always" >
        <mat-label>{{ "COMPANY_ADD_USERS.branches" | translate }}<span>*</span></mat-label>
        <input placeholder="{{ 'COMPANY_ADD_USERS.search_branches' | translate }}" #branchInput [formControl]="branchCtrl"
          [matAutocomplete]="auto" matInput
          #panel = "matAutocompleteTrigger"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" (closed) = "focusOut()">
            <mat-option value="select-all" selectAll>
              <mat-checkbox color="primary"       
              (click)="$event.stopPropagation()"
              (change)="selectAllBranches($event)"
              [checked]="checkAllSelected()"
              [indeterminate] ="checkPartialSelection()">
              <div class="flex-row">
              <h5 style="padding-bottom: 0.8rem;">{{ 'COMPANY_ADD_USERS.select_all' | translate }}</h5>
              </div>
            </mat-checkbox>
            </mat-option>
            @for (branch of filteredBranches | async; track branch) {
              @if (isEqual(branch?.status ,'Active')) {
              <mat-option [value]="branch">
               <mat-checkbox color="primary"       
               (click)="$event.stopPropagation()" 
               (change)="checkBoxChange($event,branch)"
               [checked]="checkSelected(branch)">
               <div class="flex-row">
               <h5 [ngClass]="branch.parentAccountId ? '': 'width-change'">
                {{ branch?.name }} - {{ 'INVITE.sector_no' | translate }} {{ branch?.sectorNumber || 'N/A' }}
               </h5>
               @if (!branch.parentAccountId) {
               <mat-chip>{{ 'COMPANY_BRANCHES.headQuarters' | translate }}</mat-chip>
               }
               </div>
               <p>{{ branch?.city }}, {{ branch?.state }}</p>
             </mat-checkbox>
             </mat-option>
              }
           }
         </mat-autocomplete>
      </mat-form-field>

    @for (branch of data.branchAssignments.value; track branch) {
    <div class="branches-container">
      <div class="first-line">
        <span>{{ 'INVITE.branch' | translate }}</span>
        <div><mat-icon (click)="removeBranch(branch)">close</mat-icon></div>
      </div>
      <div class="second-line">
        <div class="branch-name">{{branch?.name}} - {{ 'INVITE.sector_no' | translate }} {{ branch?.sectorNumber || 'N/A' }}</div>
        @if (branch.parentAccountId) {
        <div class="branch-toggle">
        <mat-slide-toggle color="primary" [disabled]="isAdmin" [checked]="branch.isBranchAdmin" (change)="toggleBranchAdmin(branch,$event.checked)">
          {{ 'INVITE.branch_admin_toggle' | translate }}
        </mat-slide-toggle></div>
        }
      </div>
      <div class="third-line"></div>
      {{branch?.city}},{{branch?.state}}
    </div>
    }
      <mat-slide-toggle color="primary" [checked]="isAdmin" (change)="toggleAdmin($event.checked)" (click)="$event.stopPropagation()">
        {{ 'COMPANY_ADD_USERS.company_admin' | translate }}
      </mat-slide-toggle>
    </form>
  </div>
  }
</mat-step>
<mat-step [completed]="false" [editable]="false">
  <ng-template matStepLabel>{{ 'APPS.header' | translate }}</ng-template>
  @if (stepper.selectedIndex === 2) {
  <div>
    @if (apps?.length <= 0) {
    <div>
      <h2>{{ 'APPS.no_app' | translate }}</h2>
    </div>
    }
      @for (app of apps; track app) {
      <div>
        <div class="padding">
          <mat-card-content>
            <mat-slide-toggle color="primary"
              [checked]="app.toggleState"
              (valueChanged)="reset(app, $event)"
              (change)="reset(app, $event)"
            >
              {{ app?.name }}
            </mat-slide-toggle>
          </mat-card-content>
          @if (
              (app.hasUserRole && app.toggleState) ||
              (!app.hasUserRole && app.toggleState)
            ) {
          <div
            class="application-access"
          >
            @if (app?.roles?.length <= 0) {
            <div>
              {{ 'USER_DETAILS.no_roles' | translate }}
            </div>
            }
            @for (role of app?.roles; track role) {
            <div class="role-row">
              <mat-checkbox color="primary" (change)="role.hasAccess = !role.hasAccess" (click)="$event.stopPropagation()" [checked] = "role.hasAccess">{{role?.name}}</mat-checkbox>
            </div>
            }
          </div>
          }
        </div>
      </div>
      }
  </div>
  }
</mat-step>
<mat-step [completed]="false" [editable]="false">
  <ng-template matStepLabel>{{ 'USER_DETAILS.summary' | translate }}</ng-template>
  @if (stepper.selectedIndex === 3) {
  <div class ="summary">
    <h2>{{ 'USER_DETAILS.summary' | translate }}</h2>
    <p class="email">
      <b>{{ 'USER_DETAILS.email' | translate }}</b><br>
      {{ data.email.value }}
    </p>
    <p class="branches">
      <b>{{ 'BRANCH_USERS_HEADER.branches' | translate }}</b><br>
      <span style="white-space: break-spaces;">{{ getBranchNames() }}</span>
    </p>
    <p class="company-admin">
      <b>{{ 'USER_DETAILS.company_admin' | translate }}</b><br>
      {{ isAdmin ? 'Yes' : 'No' }}
    </p>
    <h2 class="apps">{{ 'APPS.header' | translate }}</h2>
    @for (app of apps; track app) {
    <div>
      @if (app.toggleState) {
      <div>
        <p>
          {{ app.name }}:
          {{ getAppRoles(app) }}
        </p>
      </div>
      }
    </div>
    }
  </div>
  }
</mat-step>
<ng-template matStepperIcon="edit">
  <mat-icon>done</mat-icon>
</ng-template>
</mat-stepper>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div>
  <button color="warn" mat-stroked-button (click)="cancel()">{{"COMPANY_ADD_USERS.cancel" | translate}}</button>
  </div>
  <div>
  <button color="primary" mat-stroked-button (click)="goBack(stepper)" [disabled]= "stepper.selectedIndex===0" aria-label="'This is a sample button'">{{'ACTION.back' | translate}}</button>
  @if (stepper.selectedIndex !== 3) {
  <button (click)="goForward(stepper)" color="primary" mat-raised-button [disabled]="checkEmail() || stepper.selectedIndex == 1 && !hasSelectedBranch() || (stepper.selectedIndex == 2 && !allToggledAppsHaveRoles())"
  aria-label="'This is a sample button'">{{'ACTION.next' | translate}}</button>
  }
  @if (stepper.selectedIndex=== 3) {
  <button (click)="save()" color="primary" mat-raised-button [disabled]="checkEmail()">
    {{"COMPANY_ADD_USERS.invite" | translate}}
  </button>
  }
</div>
</mat-dialog-actions>
